import { rootApi } from '../rootApi';
import { HTTPRequestType } from '../api.types';

/** What Engage did with people added to its marketing list from JobTetris (JT1-1925). */
export interface EngageMarketingAddResult {
  added: number;
  already: number;
  skipped: { name: string; reason: string }[];
  over_limit: number;
  limit_message?: string;
}

export type EngageMarketingPersonType = 'candidate' | 'contact';

const engageApi = rootApi.injectEndpoints({
  endpoints: (builder) => ({
    /** Ids are OrganizationCandidate ids for candidates, Contact ids for contacts. */
    addToEngageMarketingList: builder.mutation<EngageMarketingAddResult, { type: EngageMarketingPersonType; ids: string[] }>({
      query: (data) => ({ url: '/engage/marketing-contacts', method: HTTPRequestType.POST, data }),
    }),
  }),
});

export const { useAddToEngageMarketingListMutation } = engageApi;
